import React from "react";
import "./adminComponents.scss";

function NewsItem(props) {
  const {
    title,
    content,
    creation_date,
    newstype = "General",
  } = props;

  const formatDate = (dateString) => {
    try {
      return new Date(dateString).toLocaleDateString();
    } catch (error) {
      return dateString;
    }
  };

  return (
    <div className="packageContainer" style={{ width: '90%', maxWidth: '500px' }}>
      <div className="package">
        <div className="packageTitle offer" style={{ backgroundColor: '#e3f2fd', borderRadius: '8px 8px 0 0' }}>
          {title}
          <div className="newsDate" style={{ paddingRight: '20px' }}>
            {formatDate(creation_date)}
          </div>
        </div>
        <div className="packageDetails">
          {newstype && newstype !== "General" && (
            <div className="newsType">
              Type: {newstype}
            </div>
          )}
          <div className="newsContent" style={{ whiteSpace: 'pre-wrap' }}>
            {content}
          </div>
        </div>
      </div>
    </div>
  );
}

export default NewsItem;
